//const version = process.env.REACT_APP_VERSION;
const version = "#121307";

export const getVersion = () => version;

export const VersionLabel = () => {
    return <span>Version: {version}</span>;
}